import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { toast } from "react-toastify";
import Select from "react-select";

const MaterialIssueProductWise = ({ show, handleClose, onMaterialAdded }) => {
  const [products, setProducts] = useState([]);
  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    product_id: null,
    quantity: "",
    urgency: { value: "Normal", label: "Normal" },
    reason: null,
    notes: "",
  });

  const handleSelectChange = (name, option) => {
    setForm((prev) => ({ ...prev, [name]: option }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = async () => {
    const token = getAuthToken();
    if (!token) {
      toast.error("Authentication token missing!");
      return;
    }

    try {
      const payload = {
        product_id: form.product_id?.value || "",
        quantity: form.quantity,
        urgency: form.urgency?.value || "Normal",
        reason: form.reason?.value || "",
        notes: form.notes,
      };

      const response = await axios.post(
        `${config.API}/supervisor/materialissuerequestproductwise`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      toast.success(response.data.message || "Request submitted successfully");
      setForm({
        product_id: null,
        quantity: "",
        urgency: { value: "Normal", label: "Normal" },
        reason: "",
        notes: "",
      });

      setErrors({});
      handleClose();
      onMaterialAdded();

    } catch (err) {
      if (err.response?.status === 422) {
        const errors = err.response.data || {};
        setErrors(errors);
      } else {
        toast.error(
          err.response?.data?.message || "Failed to submit material issue request!"
        );
      }
    }
  };

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    const token = getAuthToken();
    if (!token) return;

    try {
      const response = await axios.get(`${config.API}/product/list`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const formatted = response?.data?.products?.map((item) => ({
        value: item.id,
        label: item.name,
      }));

      setProducts(formatted || []);
    } catch (err) {
      console.error("Error fetching products:", err.message);
    }
  };

  const urgencyOptions = [
    { value: "Normal", label: "Normal" },
    { value: "Urgent", label: "Urgent" },
  ];

  const reasonOptions = [
    { value: "Maintenance", label: "Maintenance" },
    { value: "Project", label: "Project" },
    { value: "Replacement", label: "Replacement" },
    { value: "stock_refill", label: "stock_refill" },
  ];

  const formLabelCol = 3;
  const formInputCol = 9;
  return (
    <Modal show={show} onHide={handleClose} centered className="font_family">
      <Modal.Header closeButton className="border-0 p-4">
        <strong className="fs-5">
          Create Material Issue Request (Product Wise)
        </strong>
      </Modal.Header>

      <Modal.Body className="p-4">
        <Form>
          {/* Product */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Product
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={products}
                value={form.product_id}
                onChange={(opt) => handleSelectChange("product_id", opt)}
                placeholder="Select Product"
              />
              {errors.product_id && (
                <div className="text-danger small mt-1">
                  {errors.product_id[0]}
                </div>
              )}
            </Col>
          </Form.Group>

          {/* Quantity */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Quantity
            </Form.Label>
            <Col sm={formInputCol}>
              <Form.Control
                type="text"
                name="quantity"
                value={form.quantity}
                onChange={handleChange}
                isInvalid={!!errors.quantity}
              />
              {errors.quantity && (
                <Form.Control.Feedback type="invalid">
                  {errors.quantity[0]}
                </Form.Control.Feedback>
              )}
            </Col>
          </Form.Group>

          {/* Urgency */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Urgency
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={urgencyOptions}
                value={form.urgency}
                onChange={(opt) => handleSelectChange("urgency", opt)}
              />
            </Col>
          </Form.Group>

          {/* Reason */}
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={formLabelCol}>
              Reason
            </Form.Label>
            <Col sm={formInputCol}>
              <Select
                options={reasonOptions}
                value={form.reason}
                onChange={(opt) => handleSelectChange("reason", opt)}
                placeholder="Select reason"
              />
              {errors.reason && (
                <div className="text-danger small mt-1">
                  {errors.reason[0]}
                </div>
              )}
            </Col>
          </Form.Group>

          {/* Notes */}
          <Form.Group as={Row}>
            <Form.Label column sm={formLabelCol}>
              Notes
            </Form.Label>
            <Col sm={formInputCol}>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                value={form.notes}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button variant="dark" onClick={handleSubmit}>
          Submit Request
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MaterialIssueProductWise;
